export default __webpack_public_path__ + "static/media/emoji-laptop.7edd681a.svg";